/**
 * `parseStatBlock`, `parseSpell`, `parseItem` and `parseCharacter`: the full
 * Zod parse, refinements included. They never throw; every problem is an
 * issue with its path. Packages without a direct `zod` dependency (P0-11b)
 * use these and `SchemaIssue`.
 */
import { CharacterV1 } from './character.js';
import { ItemV1 } from './item.js';
import { SpellV1 } from './spell.js';
import { StatBlockV1 } from './statblock.js';
function parseWith(schema, value) {
    const result = schema.safeParse(value);
    if (result.success)
        return { ok: true, value: result.data };
    return {
        ok: false,
        issues: result.error.issues.map((i) => ({
            path: i.path.map((p) => (typeof p === 'number' ? p : String(p))),
            code: i.code,
            message: i.message,
        })),
    };
}
export function parseStatBlock(value) {
    return parseWith(StatBlockV1, value);
}
export function parseSpell(value) {
    return parseWith(SpellV1, value);
}
export function parseItem(value) {
    return parseWith(ItemV1, value);
}
export function parseCharacter(value) {
    return parseWith(CharacterV1, value);
}
//# sourceMappingURL=parse.js.map